import { render, staticRenderFns } from "./UnitTemplate.vue?vue&type=template&id=68b8551e&scoped=true&"
import script from "./UnitTemplate.vue?vue&type=script&lang=js&"
export * from "./UnitTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8551e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b8551e')) {
      api.createRecord('68b8551e', component.options)
    } else {
      api.reload('68b8551e', component.options)
    }
    module.hot.accept("./UnitTemplate.vue?vue&type=template&id=68b8551e&scoped=true&", function () {
      api.rerender('68b8551e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/UnitTemplate.vue"
export default component.exports